<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="600px">
            <v-card>
                <v-card-title class="ma-0 pa-0">
                    <v-toolbar dark color="blue lighten-2">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Клавиатура</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click="showHiddenKeyboards = !showHiddenKeyboards">
                                <v-icon>remove_red_eye</v-icon>
                            </v-btn>
                            <v-btn color="green darken-1" text @click="createKeyboard">Сохранить</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>

                </v-card-title>
                <v-card-text class="px-0">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-col cols="5" class="parent px-0">
                                <v-list
                                        :dense="true"
                                        style="max-height: 350px"
                                        class="overflow-y-auto"
                                >
                                    <v-list-item-group
                                            v-model="editKeyboardIndex"
                                            mandatory
                                    >
                                        <v-list-item
                                                v-for="(keyboard, index) in keyboards"
                                                :key="keyboard.id"
                                                @click="selectKeyboard(index)"
                                                style="min-height: 10px"
                                                v-show="keyboard.visible_in_list || showHiddenKeyboards"
                                                class="pr-1"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title v-text="keyboard.title"></v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action v-if="index > 1" class="ma-0">
                                                <v-btn text icon small light @click.stop="removeKeyboardIndex = index">
                                                    <v-icon small>delete</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                            <v-col cols="7" v-if="editKeyboardIndex !== 0">
                                <v-flex xs12>
                                    <v-text-field
                                            label="Название клавиатуры"
                                            required
                                            v-model="keyboardModel.title"
                                            :counter="28"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="my-0 py-0">
                                    <v-switch v-model="keyboardModel.one_time" inset label="Скрыть после нажатия"
                                              color="primary"
                                              hide-details
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="my-0 py-0">
                                    <v-switch v-model="keyboardModel.hotkey" inset label="Горячие клавиши"
                                              color="primary"
                                              hide-details
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="my-0 py-0">
                                    <v-switch
                                            v-model="keyboardModel.inline"
                                            inset
                                            label="Клавиатура встроенная в сообщение"
                                            color="primary"
                                            hide-details
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="my-0 py-0">
                                    <v-switch
                                            v-model="keyboardModel.visible_in_list"
                                            inset
                                            label="Показывать в списке клавиатур?"
                                            color="primary"
                                            hide-details
                                    ></v-switch>
                                </v-flex>
                            </v-col>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <v-dialog
                v-model="dialog"
                max-width="300"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2">Подтвердите удаление</v-card-title>

                <v-card-text>
                    Вы действительно хотите удалить?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                    >
                        Отмена
                    </v-btn>

                    <v-btn
                            color="error darken-1"
                            text
                            @click="removeKeyboard(removeKeyboardIndex)"
                    >
                        Подтверждаю
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'KeyboardForm',
    data() {
        return {
            dialog: false,
            model: 0,
            keyboardModelDef: {
                id: null,
                title: '',
                bot_id: null,
                one_time: 1,
                hotkey: 0,
                visible: 1,
                struct: [],
                inline: 0,
                visible_in_list: 0
            },
            keyboardModel: {
                id: null
            },
            snackbar: false,
            editKeyboardIndex: 0,
            removeKeyboardIndex: null,
            showHiddenKeyboards: false
        }
    },
    props: ['visible', 'messageModel'],
    methods: {
        createKeyboard() {
            if (this.keyboardModel.title.length > 28) {
                this.$dialog.notify.warning(`Название бота не может превышать 28 символов`)
            } else {
                switch (this.editKeyboardIndex) {
                case 0: // Без клавиатуры
                    this.$emit('selectKeyboard', 0)
                    break
                default:
                    this.$store.dispatch('keyboards/saveKeyboard', this.keyboardModel).then(response => {
                        this.snackbar = true
                        let keyboard = this.getKeyboardById(response.id)
                        this.$emit('selectKeyboard', keyboard.id)
                    })
                }
            }
        },
        selectKeyboard(index) {
            this.editKeyboardIndex = index
            switch (index) {
            case 0: // Без клавиатуры
                this.keyboardModel = Object.assign({}, this.keyboardModelDef)
                break
            case 1: // новая клавиатура
                this.keyboardModel = Object.assign({}, this.keyboardModelDef)
                break
            default:
                this.keyboardModel = Object.assign({}, this.keyboards[index])
            }
        },
        removeKeyboard(index) {
            this.removeKeyboardIndex = null
            this.keyboardModel = Object.assign({}, this.keyboardModelDef)
            this.$store.dispatch('keyboards/removeKeyboard', index).then(response => {
                this.snackbar = true
                this.dialog = false
            }, error => {
                console.error('Got nothing from server. Prompt user to check internet connection and try again')
            })
        },
        ...mapActions('keyboards', {
            loadKeyboards: 'loadKeyboards',
            saveKeyboard: 'saveKeyboard'
        })
    },
    computed: {
        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapGetters({
            getKeyboardById: 'keyboards/getKeyboardById',
            getKeyboardByIndex: 'keyboards/getKeyboardById',
            keyboards: 'keyboards/keyboards',
            getKeyboardIndexById: 'keyboards/getKeyboardIndexById'

        })
    },
    watch: {
        show() {
            this.editKeyboardIndex = 0
            this.keyboardModel = Object.assign({}, this.keyboardModelDef)
            if (this.show && this.messageModel.keyboard_id != null) {
                this.keyboardModel = Object.assign({}, this.getKeyboardById(this.messageModel.keyboard_id))
                this.editKeyboardIndex = this.getKeyboardIndexById(this.messageModel.keyboard_id)
            }
        },
        removeKeyboardIndex() {
            if (this.removeKeyboardIndex != null) {
                this.dialog = true
            }
        }
    },
    created() {
        this.keyboardModelDef.bot_id = this.$route.params['pathMatch']
    }
}
</script>

<style scoped>

</style>
